import { render, staticRenderFns } from "./BrandCampaignItem.vue?vue&type=template&id=3b23b84e&scoped=true&"
import script from "./BrandCampaignItem.vue?vue&type=script&lang=js&"
export * from "./BrandCampaignItem.vue?vue&type=script&lang=js&"
import style0 from "./BrandCampaignItem.vue?vue&type=style&index=0&id=3b23b84e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b23b84e",
  null
  
)

export default component.exports